// extracted by mini-css-extract-plugin
module.exports =  {"geosuggest-popup":"_2787e5dfdf--geosuggest-popup--j8epB","suggestion-list":"_2787e5dfdf--suggestion-list--NRzbC"};